import { Box } from '@mui/material'
import ViewActionButton from './ViewActionButton';

interface Props {
  id: string;
  refetch?: () => void;
}

export default function ProductActionButtons({ id }: Props) {
  return (
    <Box
      display={'flex'}
      gap={1}
    >
      <ViewActionButton path={`${id}`} />
    </Box>
  )
}
